import { Spin, Table } from "antd";
import { useEffect, useState } from "react";
import useSeguros from "routes/preciosV2/Editar/components/Seguros/useSeguros";
import Editar from "./Editar";
import useColumns from "./useColumns";

const Seguros = ({
  precioId,
  preciosSeguros,
  setPreciosSeguros,
  setHasUnsavedChanges,
}) => {
  const { preciosSeguros: initialPreciosSeguros, loading, fetch } = useSeguros(null, 'vigente', null, "ACUERDOS");
  const segurosActuales = preciosSeguros.find(p => p.id === precioId)?.seguros ?? [];
  const [openEditar, setOpenEditar] = useState();
  const { columns, components } = useColumns(precioId, setPreciosSeguros, setHasUnsavedChanges, setOpenEditar);

  const handleEditValorDeclarado = (values) => {
    setPreciosSeguros(prev =>
      prev.map(p =>
        p.id === precioId
          ? {
            ...p,
            seguros: p.seguros.map(item => ({
              ...item,
              // Aplica solo lo que venga desde el modal
              ...(values.seguro_maximo !== undefined && {
                seguro_maximo: values.seguro_maximo
              }),
              ...(values.seguro_sin_documentacion !== undefined && {
                seguro_sin_documentacion: values.seguro_sin_documentacion
              }),
              editado: true, // igual que handleEdit
            }))
          } : p
      )
    );

    setHasUnsavedChanges(prev => ({
      ...prev,
      [precioId]: true,  // igual que handleEdit
    }));

    setOpenEditar(false);
  }

  useEffect(() => {
    if (precioId) fetch(precioId);
  }, [precioId]);

  useEffect(() => {
    if (!initialPreciosSeguros) return;

    setPreciosSeguros(prev => {
      const segurosActuales = initialPreciosSeguros
        .filter(s => s.precios_id === precioId)
        .map(s => ({ ...s, editado: false }));

      const existe = prev.find(p => p.id === precioId);

      if (existe) {
        return prev.map(p =>
          p.id === precioId
            ? { ...p, seguros: segurosActuales }
            : p
        );
      }

      return [
        ...prev,
        { id: precioId, seguros: segurosActuales }
      ];
    });
  }, [precioId, initialPreciosSeguros]);

  return (
    <Spin spinning={loading}>
      <Table
        rowKey="id"
        size="small"
        rowClassName="editable-row small-font"
        bordered
        loading={loading}
        dataSource={segurosActuales}
        columns={columns}
        pagination={false}
        components={components}
        scroll={{
          x: 'min-content',
          ...segurosActuales?.length > 5
            ? { y: 'calc(100vh * 0.35)' }
            : {}
        }}
      />
      {openEditar &&
        <Editar
          onFinish={handleEditValorDeclarado}
          closeModal={() => setOpenEditar(false)}
        />
      }
    </Spin>
  );
}

export default Seguros;